import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/portal";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-background-200/80" : "bg-background-50/60 backdrop-blur border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-shuffle-line text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-[15px] font-bold tracking-wide text-foreground-950">吃瓜线路</span>
            <span className="mt-1 text-[10px] tracking-[0.18em] text-foreground-500">切换指南 · 参考站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <button
            type="button"
            className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-2 text-sm text-foreground-500 transition-colors hover:border-primary-300 md:flex"
            aria-label="搜索线路"
          >
            <i className="ri-search-line text-[15px]" aria-hidden="true" />
            <span className="hidden xl:inline">搜线路 / 测速关键字</span>
            <kbd className="font-num hidden rounded bg-background-200 px-1.5 text-[10px] text-foreground-600 lg:inline">⌘K</kbd>
          </button>
          <a
            href="#compare"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-block"
          >
            看线路对比
          </a>
          <button
            type="button"
            className="grid h-9 w-9 place-items-center rounded-lg border border-background-200 bg-background-50 text-foreground-700 lg:hidden"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="展开菜单"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-lg`} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-lg px-2 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#compare"
              onClick={() => setMenuOpen(false)}
              className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-center text-sm font-semibold text-background-50"
            >
              看线路对比
            </a>
          </div>
        </div>
      )}
    </header>
  );
}